<template>
    <div @mousedown.prevent class="w-100 z-2 bg-nord5 bar">
      <div class="flex justify-between items-center w-100 pa3 center mw8">
        <div>
          <i @click="$parent.track" class="dim ph3 fa fa-play" aria-hidden="true" id="play-btn"></i>
          <span id="dent">
            <i @click="dedent" class="dim ph3 fa fa-outdent" aria-hidden="true" id="dedent-btn"></i>
            <i @click="indent" class="dim ph3 fa fa-indent" aria-hidden="true" id="indent-btn"></i>
          </span>
          <i @click="$parent.viewStats" data-tooltip="View Statistics" class="tooltip ph3 fa fa-bar-chart" aria-hidden="true" id="stats-btn"></i>
          <i @click="updateTime" data-tooltip="Edit time tracked" class="tooltip ph3 fa fa-clock-o" aria-hidden="true" id="edit-btn"></i>
        </div>
        <div>
          <i @click="remove" class="nord11 dim ph3 fa fa-lg fa-trash" aria-hidden="true" id="delete-btn"></i>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  data: function(){
    return {
      maxDate: new Date().toDateInputValue(),
    }
  },
  props: ["task"],
  mounted(){
    this.$root.$on('delete', task => { 
      if(task.id == this.task.id){
          this.$parent.remove()
      }
    })
  },
  methods: {
    remove(){
      this.$root.$emit("trackingTask", (status, task) => {
        if(status && this.task.getChild(task.id) != null){
          alert("You cannot delete this task as it (or something nested underneath it) is being tracked!")
        } else if(confirm("Are you sure you want to delete this task and all of its children?")){
          this.$parent.remove()
        }
      })
    },
    indent(){
      this.$parent.handleTab({shiftKey: false})
    },
    dedent(){
      this.$parent.handleTab({shiftKey: true})
    },
    updateTime(){
      this.$root.$emit("modify", this.task)
    }
  }
}
</script>
<style>
.bar {
  position: fixed;
  bottom: 0px;
  left: 0px;
}
</style>
